import { Empty, Grid, LimitMore, Selection, Toolbar } from "@/components/collection"
import { PageContent } from "@/components/layout/dashboard"
import { useFilteredArticles } from "@/store/articles/hooks"
import { usePageContext } from "./Context"
import { Item } from "./Item"

/**
 * dictionary src/dictionaries/en/pages/dashboard/offers.json
 */
const dictionary = createContextMapper("pages", "dashboard", "offers")

/**
 * Collection
 */
export const Collection: React.FC = () => {
  const { _ } = useDictionary(dictionary())
  const { articles, filtered, filterable, sortable, matchable, limitable, limit } =
    useFilteredArticles(["offers"])
  const {
    view,
    setView,
    create,
    selected,
    setSelected,
    confirmDeleteSelection,
    confirmPublishSelection,
    confirmUnpublishSelection,
  } = usePageContext()
  return (
    <PageContent>
      <Selection
        selected={selected}
        unselect={() => setSelected([])}
        deleteSelection={confirmDeleteSelection}
        publishSelection={confirmPublishSelection}
        unpublishSelection={confirmUnpublishSelection}
      />
      <Toolbar>
        <Toolbar.Search {...matchable} />
        <Toolbar.Button onClick={create}>{_("create")}</Toolbar.Button>
        <Toolbar.Sort {...sortable} dictionary={Toolbar.Sort.dictionary(dictionary("sort"))} />
        <Toolbar.View {...{ view, setView }} />
      </Toolbar>
      <Empty
        items={articles}
        results={filtered}
        create={create}
        clear={() => {
          matchable.setSearch("")
          filterable.clear()
          setSelected([])
        }}
      />
      <Grid {...{ view }}>
        {A.map(limit(filtered), article => (
          <Item key={article.id} article={article} />
        ))}
      </Grid>
      <LimitMore {...limitable} />
    </PageContent>
  )
}
export default Collection
